export function ticketDate(value) {
  if (!value) return null;
  const normalized = String(value).replace(' ', 'T');
  const parsed = new Date(/^\d{4}-\d{2}-\d{2}$/.test(normalized) ? `${normalized}T00:00:00Z` : /Z$|[+-]\d\d:?\d\d$/.test(normalized) ? normalized : `${normalized}Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function durationHours(start, end) {
  const first = ticketDate(start);
  const last = ticketDate(end);
  return first && last && last >= first ? Math.round((last - first) / 360000) / 10 : null;
}

export function durationLabel(hours) {
  if (hours === null) return 'Non renseigné';
  if (hours < 48) return `${hours.toLocaleString('fr-FR')} h`;
  return `${(hours / 24).toLocaleString('fr-FR', {maximumFractionDigits:1})} j`;
}

export function periodKey(value, period) {
  const date = ticketDate(value);
  if (!date) return null;
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  if (period === 'month') return `${year}-${month}`;
  const monday = new Date(Date.UTC(year, date.getUTCMonth(), date.getUTCDate()));
  monday.setUTCDate(monday.getUTCDate() - (monday.getUTCDay() + 6) % 7);
  return monday.toISOString().slice(0, 10);
}

export function ticketHistory(tickets, period) {
  const buckets = new Map();
  for (const ticket of tickets) {
    for (const [field, metric] of [['createDate','created'], ['resolvedDate','resolved'], ['closedDate','closed']]) {
      const key = periodKey(ticket[field], period);
      if (!key) continue;
      if (!buckets.has(key)) buckets.set(key, {period:key, created:0, resolved:0, closed:0});
      buckets.get(key)[metric]++;
    }
  }
  return [...buckets.values()].sort((a,b) => a.period.localeCompare(b.period));
}

export function groupTicketsByPeriod(tickets, period) {
  const buckets = new Map();
  for (const ticket of tickets) {
    const key = periodKey(ticket.createDate, period) || 'unknown';
    if (!buckets.has(key)) buckets.set(key, {period:key,tickets:[]});
    buckets.get(key).tickets.push(ticket);
  }
  return [...buckets.values()].sort((a,b) => a.period === 'unknown' ? 1 : b.period === 'unknown' ? -1 : b.period.localeCompare(a.period));
}

export function periodLabel(key, period) {
  if (key === 'unknown') return 'Date de création non renseignée';
  const value = period === 'month' ? `${key}-01` : key;
  const date = ticketDate(value);
  if (!date) return key;
  const formatted = date.toLocaleDateString('fr-FR', {timeZone:'UTC',month:'long',year:'numeric',...(period === 'week' ? {day:'numeric'} : {})});
  return period === 'week' ? `Semaine du ${formatted}` : formatted[0].toUpperCase() + formatted.slice(1);
}

export function averageDuration(tickets, field) {
  const values = tickets.map(ticket => durationHours(ticket.createDate, ticket[field])).filter(value => value !== null);
  return values.length ? Math.round(values.reduce((sum,value) => sum + value,0) / values.length * 10) / 10 : null;
}
